import { IMPRESSION_ACTIONS, SCREEN_NAME } from "@cart-client/analytics/constants";
import { AnalyticsContextValue } from "@swiggy-private/checkout-core";

export const hotelInRoomDeliveryCroutonImpressionEvent = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    cartId: string,
    errorText: string,
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_HOTEL_DELIVERY_ERROR_TOAST,
        label: errorText,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        context: JSON.stringify({ cart_id: cartId }),
    });
};

